import * as yup from 'yup';

export const validationPasswordSchema = yup.object({
    password: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('passwordconfirm'), null], 'Password not matched'),
    passwordconfirm: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('password'), null], 'Password not matched'),
})

export const validationSchema = yup.object({
    username: yup
        .string()
        .required('Required'),
    firstname: yup
        .string()
        .required('Required'),
    lastname: yup
        .string()
        .required('Required'),
    companyname: yup
        .string()
        .required('Required'),
    regno: yup
        .string()
        .required('Required'),
    code: yup
        .string()
        .required('Required'),
    accountcode: yup
        .string()
        .required('Required'),
    email: yup
        .string()
        .email('Enter a valid email')
        .required('Required'),
    contactno: yup
        .number()
        .typeError("Only number")
        .required('Required')
        .test(
            "is-positive",
            "Please enter a positive number",
            (value) => value >= 0 && 1 / value !== -Infinity),
    status: yup
        .bool()
        .required('Required'),
})

export const initialPasswordValues = {
    password:"",
    passwordconfirm:"",
}

export const initialValues = {
    username: "",
    firstname: "",
    lastname: "",
    contactno: "",
    companyname: "",
    regno:"",
    code: "",
    accountcode:"",
    email:"",
    status: true,
    remark: "",
    businessId: "",
    differentBusiness: true
}